import axios from "../config/axios"

// Note: the axios instance logs the user out on any 403, so only call endpoints the user has access to
// (e.g. getAll is admin-only).
export const ProjectRepository = {
  // admin only
  getAll: () => {
    return axios.get(`/api/project/all`);
  },
  // projects the user is a member of, plus projects of the user's organizations
  getMy: () => {
    return axios.get(`/api/project/my`);
  },
  // a Spring page of ProjectListDTO (ProjectDTO + masked `members`), newest first: the projects the user can view
  // (every project for admins). page is zero-based; organizationId / type (VOICE_ASSISTANT | CHATBOT) are optional
  getPaged: ({page = 0, size = 10, organizationId, type, signal} = {}) => {
    const params = {page, size};
    if (organizationId !== undefined && organizationId !== null) params.organizationId = organizationId;
    if (type) params.type = type;
    return axios.get(`/api/project/paged`, {params, signal});
  },
  getById: (id) => {
    return axios.get(`/api/project/${id}`);
  },
  // project.subProjects: [{name?, description?, languageId}], one sub project is created per entry
  create: (project) => {
    return axios.post(`/api/project`, project);
  },
  // sub projects are managed through the sub project endpoints
  edit: (id, project) => {
    return axios.put(`/api/project/${id}`, project);
  },
  delete: (id) => {
    return axios.delete(`/api/project/${id}`);
  },

  getMembers: (id) => {
    return axios.get(`/api/project/${id}/member`);
  },
  // member: {username, role, vdn}
  addMember: (id, member) => {
    return axios.post(`/api/project/${id}/member`, member);
  },
  // member: {role, vdn}
  editMember: (id, memberId, member) => {
    return axios.put(`/api/project/${id}/member/${memberId}`, member);
  },
  removeMember: (id, memberId) => {
    return axios.delete(`/api/project/${id}/member/${memberId}`);
  },
}

export const SubProjectRepository = {
  getByProject: (projectId) => {
    return axios.get(`/api/sub-project/project/${projectId}`);
  },
  getById: (id) => {
    return axios.get(`/api/sub-project/${id}`);
  },
  create: (subProject) => {
    return axios.post(`/api/sub-project`, subProject);
  },
  // null fields keep their current value; a given voice/transcribe/core configuration replaces the current one
  edit: (id, subProject) => {
    return axios.put(`/api/sub-project/${id}`, subProject);
  },
  delete: (id) => {
    return axios.delete(`/api/sub-project/${id}`);
  },

  // newest first
  getVersions: (id) => {
    return axios.get(`/api/sub-project/${id}/version`);
  },
  // a PRODUCTION version also becomes the sub project's productionVersion
  createVersion: (id, version) => {
    return axios.post(`/api/sub-project/${id}/version`, version);
  },
}
